import { Stack, Typography } from '@mui/material';

const Terms = () => {
  return (
    <div>
      <Typography variant="h4" sx={{ fontWeight: 'bold' }} gutterBottom>
        Brukervilkår og personvern
      </Typography>
      <Stack spacing={2} mt={2}>
        <Typography variant="body1" sx={{ maxWidth: '500px' }} gutterBottom>
          1. Ved å opprette bruker og ta i bruk applikasjonen godtar jeg at nødvendig informasjon lagres og brukes i tråd med
          GDPR-regelverket (General data protection regulation) og slettes fra systemet etter bruk.
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: '500px' }} gutterBottom>
          2. Du kan når som helst ta kontakt med Hof IL (eier) for å be om sletting av dine opplysninger.
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: '500px' }} gutterBottom>
          3. Netcode As som utvikler og drifter applikasjonen vil ikke bruke data som lagres til egne formål.
        </Typography>
      </Stack>
    </div>
  );
};

export default Terms;
